var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"mt-4 text-h5"},[_vm._v("👋🤖 Скоро тут будет обзор по гостям")])])
}]

export { render, staticRenderFns }